export default class MatrixItemClass {
    constructor(
      
      public title?: string,
      public description?:string,
      public value?:string,
      public index?:number
    ) {}
  }
  